import request from '@/api/axios';

// 搜索框
const getSearch = (params: object) => {
  return request({
    url: '/product/api/search/bar',
    method: 'post',
    data: params
  });
};

// 商品详情
const getDetails = (params: object) => {
  return request({
    url: '/product/api/spu/info/detail',
    method: 'get',
    data: params
  })
}

// 查询同类商品
const getSimilarSpuList = (id: string) => {
  return request({
    url: '/product/api/spu/similarSpuList',
    method: 'get',
    data: {
      spuId: id
    }
  })
}
// 相似商品数
const getSimilarSpuNumber = (params: object) => {
  return request({
    url: '/product/api/search/getSimilarAttrSpuCount',
    method: 'post',
    data: params
  })
}
//查看全部供应商
const getSupplierList = (params: object) => {
  return request({
    url: '/product/api/brand/supplierList',
    method: 'get',
    data: params
  })
}

//获取 "订货服务" 相关的品牌列表
const getBrandList = () => {
  return request({
    url: '/product/api/brand/listBrandUnderOrderingGoods',
    method: 'get'
  })
}

//获取 "订货服务" 相关的品牌列表
const getSpuList = (params: Number) => {
  return request({
    url: '/product/api/product/spu/listSpuUnderOrderingGoods',
    method: 'get',
    data : {
      limit : params
    }
  })
}

const goodsApi = {
  getSearch,
  getDetails,
  getSimilarSpuList,
  getSimilarSpuNumber, 
  getSupplierList,
  getBrandList,
  getSpuList
}

export default goodsApi